module.exports = __webpack_public_path__ + "img/catharina-maria-bugge-p.a50235e9.webp";